module.exports = __webpack_public_path__ + "img/no_enig.b392fa1e.svg";